module.exports = __webpack_public_path__ + "static/new-filters-cover-0b03b6663d53df8a88c6ba6696a175b7.png";